/*
Controller: Asset

Operations:
  createPresignedUrlForAsset
  getAssetsAvStatus
*/
var Api = require('../config')
var CreatePresignedUrlRequestDef = require('../definitions/CreatePresignedUrlRequest')

var Asset = (function () {
  /*
  Operation: createPresignedUrlForAsset
  This accepts MD5 in the request and returns presigned URL for uploading the files.
  Parameters:
    relationWith: relationWith to check foundry or bundle

  Responses:
    HTTP 200: Presigned URL for the provided MD5
    HTTP 400: md5 not valid.
    HTTP 403: Operation not permitted
  */
  function createPresignedUrlForAssetAsset (relationWith, bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        if (!relationWith) {
          throw new Error('relationWith: Missing parameter')
        }
        if (relationWith && !(typeof relationWith === 'string')) {
          throw new Error('relationWith: Wrong type: Got "' + (typeof relationWith) + '", but expected: "string"')
        }
        CreatePresignedUrlRequestDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      parameters['relationWith'] = relationWith
      var path = '/asset/createPresignedUrl'
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: getAssetsAvStatus
  This accepts ID in the path along with relationWith param and returns assets data.
  Parameters:
    id: id of foundry or bundle to get the assests
    relationWith: relationWith to check foundry or bundle
  Responses:
    HTTP 200: Asset response
    HTTP 400: id not valid.
    HTTP 403: Operation not permitted
  */
  function getAssetsAvStatusAsset (id, relationWith) {
    return new Promise(function (resolve, reject) {
      try {
        if (!id) {
          throw new Error('id: Missing parameter')
        }
        if (id && !(typeof id === 'string')) {
          throw new Error('id: Wrong type: Got "' + (typeof id) + '", but expected: "string"')
        }
        if (!relationWith) {
          throw new Error('relationWith: Missing parameter')
        }
        if (relationWith && !(typeof relationWith === 'string')) {
          throw new Error('relationWith: Wrong type: Got "' + (typeof relationWith) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters['relationWith'] = relationWith
      var path = '/asset/{id}'
      path = path.replace('{' + 'id' + '}', id)
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  var ret = {}
  ret['createPresignedUrlForAsset'] = createPresignedUrlForAssetAsset
  ret['getAssetsAvStatus'] = getAssetsAvStatusAsset
  return ret
})()

module.exports = Asset
